/**
 * Different log types we can log messages as based on RFC5424 (https://datatracker.ietf.org/doc/html/rfc5424).
 */
export var LogType;
(function (LogType) {
    LogType[LogType["error"] = 0] = "error";
    LogType[LogType["warn"] = 1] = "warn";
    LogType[LogType["info"] = 2] = "info";
    LogType[LogType["http"] = 3] = "http";
    LogType[LogType["verbose"] = 4] = "verbose";
    LogType[LogType["debug"] = 5] = "debug";
    LogType[LogType["silly"] = 6] = "silly";
})(LogType || (LogType = {}));
